import React from 'react';
import Modal from 'react-modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { T, useTranslate } from 'shared/helper/translate';
import { trackGetRubriqAddinClicked } from 'researcher/helpers/mixpanelEvents';
import RubriqLogo from '../images/rubriq-logo-rgb-color-light-32x119.jpg';
var MICROSOFT_APPSOURCE_URL = 'https://appsource.microsoft.com/en-us/product/office/WA200005612?tab=Overview';
var WordDocIcon = function WordDocIcon() {
  return /*#__PURE__*/React.createElement("div", {
    className: "word-doc-icon"
  }, /*#__PURE__*/React.createElement("svg", {
    className: "word-doc-icon-svg",
    width: "36",
    height: "52",
    viewBox: "0 0 48 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 2 H34 L46 14 V64 Q46 66 44 66 H4 Q2 66 2 64 V4 Q2 2 4 2 Z",
    fill: "#ffffff",
    stroke: "#c8cdd8",
    strokeWidth: "1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 2 L46 14 H36 Q34 14 34 12 Z",
    fill: "#ffffff",
    stroke: "#c8cdd8",
    strokeWidth: "1"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "26",
    y1: "30",
    x2: "40",
    y2: "30",
    stroke: "#e4e8f0",
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "26",
    y1: "38",
    x2: "40",
    y2: "38",
    stroke: "#e4e8f0",
    strokeWidth: "2",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("div", {
    className: "word-doc-icon-badge"
  }, /*#__PURE__*/React.createElement("span", {
    className: "word-doc-icon-letter"
  }, " W")));
};
var WordRibbonIcon = function WordRibbonIcon() {
  return /*#__PURE__*/React.createElement("div", {
    className: "word-ribbon-icon"
  }, /*#__PURE__*/React.createElement("div", {
    className: "word-ribbon-tabs"
  }, ['File', 'Home', 'Insert', 'Design'].map(function (tab) {
    return /*#__PURE__*/React.createElement("span", {
      key: tab,
      className: "word-ribbon-tab ".concat(tab === 'Home' ? 'word-ribbon-tab-active' : '')
    }, tab);
  })), /*#__PURE__*/React.createElement("div", {
    className: "word-ribbon-body"
  }, /*#__PURE__*/React.createElement("svg", {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "1",
    y: "1",
    width: "4.5",
    height: "4.5",
    rx: "0.5",
    stroke: "#185abd",
    strokeWidth: "1.2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "8.5",
    y: "1",
    width: "4.5",
    height: "4.5",
    rx: "0.5",
    stroke: "#185abd",
    strokeWidth: "1.2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "1",
    y: "8.5",
    width: "4.5",
    height: "4.5",
    rx: "0.5",
    stroke: "#185abd",
    strokeWidth: "1.2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "8.5",
    y: "8.5",
    width: "4.5",
    height: "4.5",
    rx: "0.5",
    stroke: "#185abd",
    strokeWidth: "1.2"
  })), /*#__PURE__*/React.createElement("span", {
    className: "word-ribbon-label"
  }, "Add-ins")));
};
var SearchAndLogoIcon = function SearchAndLogoIcon() {
  return /*#__PURE__*/React.createElement("div", {
    className: "word-search-logo-icon"
  }, /*#__PURE__*/React.createElement("div", {
    className: "word-search-box"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "magnifying-glass",
    className: "word-search-icon"
  }), /*#__PURE__*/React.createElement("span", {
    className: "word-search-text"
  }, "Rubriq")), /*#__PURE__*/React.createElement("div", {
    className: "word-search-logo-wrapper"
  }, /*#__PURE__*/React.createElement("img", {
    src: RubriqLogo,
    alt: "Rubriq",
    className: "word-search-logo"
  })));
};
var Step = function Step(_ref) {
  var number = _ref.number,
    icon = _ref.icon,
    title = _ref.title,
    description = _ref.description,
    isLast = _ref.isLast;
  return /*#__PURE__*/React.createElement("div", {
    className: "word-addin-step"
  }, /*#__PURE__*/React.createElement("div", {
    className: "word-addin-step-number"
  }, number), /*#__PURE__*/React.createElement("div", {
    className: "word-addin-step-content ".concat(isLast ? 'word-addin-step-content-last' : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: "word-addin-step-icon"
  }, icon), /*#__PURE__*/React.createElement("div", {
    className: "word-addin-step-copy"
  }, /*#__PURE__*/React.createElement("span", {
    className: "word-addin-step-title"
  }, title), /*#__PURE__*/React.createElement("span", {
    className: "word-addin-step-description"
  }, description))));
};
var WordAddinModal = function WordAddinModal(_ref2) {
  var open = _ref2.open,
    onClose = _ref2.onClose,
    userAddinStatus = _ref2.userAddinStatus,
    planName = _ref2.planName,
    billingCycle = _ref2.billingCycle,
    hasActivePlan = _ref2.hasActivePlan;
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  var steps = [{
    number: 1,
    icon: /*#__PURE__*/React.createElement(WordDocIcon, null),
    title: /*#__PURE__*/React.createElement(T, {
      source: "word-addin-modal-step-1-title"
    }),
    description: /*#__PURE__*/React.createElement(T, {
      source: "word-addin-modal-step-1-description"
    })
  }, {
    number: 2,
    icon: /*#__PURE__*/React.createElement(WordRibbonIcon, null),
    title: /*#__PURE__*/React.createElement(T, {
      source: "word-addin-modal-step-2-title"
    }),
    description: /*#__PURE__*/React.createElement(T, {
      source: "word-addin-modal-step-2-description"
    })
  }, {
    number: 3,
    icon: /*#__PURE__*/React.createElement(SearchAndLogoIcon, null),
    title: /*#__PURE__*/React.createElement(T, {
      source: "word-addin-modal-step-3-title"
    }),
    description: /*#__PURE__*/React.createElement(T, {
      source: "word-addin-modal-step-3-description"
    })
  }];
  return /*#__PURE__*/React.createElement(React.Fragment, null, open && /*#__PURE__*/React.createElement(Modal, {
    appElement: window.document.querySelector('#researcher-app'),
    className: "react-modal react-modal-word-addin",
    isOpen: true,
    overlayClassName: "react-modal-overlay"
  }, /*#__PURE__*/React.createElement("div", {
    className: "react-modal-header word-addin-header"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn-close",
    onClick: function onClick() {
      return onClose();
    },
    "aria-label": t('close')
  }, /*#__PURE__*/React.createElement("span", {
    "aria-hidden": "true"
  }, "\xD7")), /*#__PURE__*/React.createElement("h1", {
    className: "react-modal-title word-addin-title"
  }, /*#__PURE__*/React.createElement(T, {
    source: "word-addin-modal-title"
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-muted mt-1 mb-0 word-addin-subtitle"
  }, /*#__PURE__*/React.createElement(T, {
    source: "word-addin-modal-subtitle"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "react-modal-content word-addin-content"
  }, steps.map(function (step, index) {
    return /*#__PURE__*/React.createElement(Step, {
      key: step.number,
      number: step.number,
      icon: step.icon,
      title: step.title,
      description: step.description,
      isLast: index === steps.length - 1
    });
  })), /*#__PURE__*/React.createElement("div", {
    className: "react-modal-footer word-addin-footer"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center me-auto gap-2 word-addin-security"
  }, /*#__PURE__*/React.createElement("div", {
    className: "word-addin-security-icon"
  }, /*#__PURE__*/React.createElement("svg", {
    width: "20",
    height: "22",
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 1L2 4.5V10C2 14.97 5.5 19.56 10 21C14.5 19.56 18 14.97 18 10V4.5L10 1Z",
    fill: "none",
    stroke: "#1a7a6e",
    strokeWidth: "1.6",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 11L9 13.5L13.5 8.5",
    stroke: "#1a7a6e",
    strokeWidth: "1.7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("span", {
    className: "word-addin-security-text"
  }, /*#__PURE__*/React.createElement(T, {
    source: "word-addin-modal-secure-message"
  }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(T, {
    source: "word-addin-modal-available-on"
  }), ' ', /*#__PURE__*/React.createElement("a", {
    href: MICROSOFT_APPSOURCE_URL,
    target: "_blank",
    rel: "noopener noreferrer",
    className: "word-addin-appsource-link"
  }, /*#__PURE__*/React.createElement(T, {
    source: "word-addin-modal-appsource-link"
  })))), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "word-addin-got-it-btn",
    "aria-label": t('word-addin-modal-got-it'),
    onClick: function onClick() {
      return onClose();
    }
  }, /*#__PURE__*/React.createElement(T, {
    source: "word-addin-modal-got-it"
  })), /*#__PURE__*/React.createElement("a", {
    href: MICROSOFT_APPSOURCE_URL,
    target: "_blank",
    rel: "noopener noreferrer",
    className: "word-addin-get-addin-btn",
    "aria-label": t('word-addin-modal-get-addin'),
    onClick: function onClick() {
      trackGetRubriqAddinClicked({
        userAddinStatus: userAddinStatus,
        planName: planName,
        billingCycle: billingCycle,
        hasActivePlan: hasActivePlan
      });
    }
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "bag-shopping"
  }), /*#__PURE__*/React.createElement(T, {
    source: "word-addin-modal-get-addin"
  })))));
};
export default WordAddinModal;